module.exports = __webpack_public_path__ + "img/BannerColaboradoresyPymeDesktop.f50d8c8a.jpg";